import React, { Fragment } from "react";

const PlanSyncTable = ({ data }) => {

    return (
        <Fragment>
            <p>
                <strong>Total Record:</strong> <span>{data.length}</span>
            </p>
            <div className="table-responsive mt-3">
                <table className="table table-stripped table-hover">
                    <thead className="thead-light">
                        <tr>
                            <th>Profile ID</th>
                            <th>Profile Details Id</th>
                            <th>Name</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>RM</th>
                            <th>Advisor</th>
                            <th>Plan Created Date</th>
                            <th>UTM Source</th>
                            <th>UTM Campaign</th>
                            <th>UTM Medium</th>
                            <th>Contact Id</th>
                            <th>Contact Created Date</th>
                            <th>Account ID</th>
                            <th>Plan Stage</th>
                            <th>profile Status</th>
                            <th>Planner Email</th>
                            <th>RM Email</th>
                            <th>Plan Status</th>
                            <th>Plan Status Date</th>
                            <th>Key Event Date</th>
                            <th>created</th>
                            <th>Risk Description</th>
                            <th>Risk Created</th>
                            <th>Risk PDF</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.length > 0 ? (
                            data.map((row, index) => (
                                <tr key={index}>
                                    <td>{row.profile_id}</td>
                                    <td>{row.profile_details_id}</td>
                                    <td>{row.name}</td>
                                    <td>{row.FirstName}</td>
                                    <td>{row.LastName}</td>
                                    <td>{row.email}</td>
                                    <td>{row.phone}</td>
                                    <td>{row.shortName1}</td>
                                    <td>{row.admin_name}</td>
                                    <td>{row.create_on}</td>
                                    <td>{row.UTMSource}</td>
                                    <td>{row.UTMCampaign}</td>
                                    <td>{row.UTMMedium}</td>
                                    <td>{row.contact_id}</td>
                                    <td>{row.ContactCreatedDate}</td>
                                    <td>{row.account_id}</td>
                                    <td>{row.PlanStage}</td>
                                    <td>{row.profileStatus}</td>
                                    <td>{row.planner_email}</td>
                                    <td>{row.rm_email}</td>
                                    <td>{row.planStatusCurrent}</td>
                                    <td>{row.fpstatusDate}</td>
                                    <td>{row.key_event_date}</td>
                                    <td>{row.create_on}</td>
                                    <td>{row.risk_description}</td>
                                    <td>{row.risk_profile_date}</td>
                                    <td>{row.ref_doc}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="27" className="text-center">
                                    No data found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </Fragment>
    );
};

export default PlanSyncTable;
